import { render, staticRenderFns } from "./error-404.vue?vue&type=template&id=e964a5b0&scoped=true"
import script from "./error-404.vue?vue&type=script&lang=js"
export * from "./error-404.vue?vue&type=script&lang=js"
import style0 from "./error-404.vue?vue&type=style&index=0&id=e964a5b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e964a5b0",
  null
  
)

export default component.exports